import { render, staticRenderFns } from "./DuplicateIncidentLogsTable.vue?vue&type=template&id=1a298744&"
import script from "./DuplicateIncidentLogsTable.vue?vue&type=script&lang=js&"
export * from "./DuplicateIncidentLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateIncidentLogsTable.vue?vue&type=style&index=0&id=1a298744&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports